<template>
  <div class="stat-card">
    <div>{{ label }}</div>
    <div class="stat-value" :style="{ color: valueColor || '#00ff88' }">{{ value }}</div>
    <div v-if="storageInfo" class="storage-info">/ {{ storageInfo }}</div>
    <div v-if="progress !== undefined" class="progress-bar">
      <div class="progress-fill" :style="{ width: `${Math.min(100, progress)}%`, background: progressColor || 'linear-gradient(90deg, #00ff88, #00cc6a)' }"></div>
    </div>
    <div v-if="extraInfo" class="extra-info">{{ extraInfo }}</div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  label: string;
  value: string | number;
  storageInfo?: string;
  progress?: number;
  progressColor?: string;
  valueColor?: string;
  extraInfo?: string;
}>();
</script>

<style scoped>
.stat-card {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid #444;
  border-radius: 8px;
  padding: 15px;
  text-align: center;
}
.stat-value {
  font-size: 1.5em;
  font-weight: bold;
  margin-top: 5px;
}
.storage-info {
  font-size: 0.8em;
  color: #888;
  margin-top: 5px;
}
.extra-info {
  font-size: 0.8em;
  color: #ffaa00;
  margin-top: 5px;
}
.progress-bar {
  width: 100%;
  height: 20px;
  background: #333;
  border-radius: 10px;
  overflow: hidden;
  margin: 10px 0;
}
.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #00ff88, #00cc6a);
  transition: width 0.3s ease;
}
</style> 